// Bundle Monaco locally instead of the jsdelivr CDN that @monaco-editor/react
// loads by default — so the code editor works 100% offline. We pull the editor
// API + the Python language contribution (a main-thread Monarch tokenizer, so
// there are no worker files to fetch over the network).
import { loader } from '@monaco-editor/react';
import * as monaco from 'monaco-editor/esm/vs/editor/editor.api';
import 'monaco-editor/esm/vs/basic-languages/python/python.contribution';

loader.config({ monaco });
